module.exports = __webpack_public_path__ + "static/img/port1.e36e594.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/port1.png
// module id = TNff
// module chunks = 1